module.exports = {
    "source_code": "HLXEMS",
    "site_id": "mba.grad.lvc.edu",
    "title": "Lebanon Valley College",
    "tfn": "",
    "url": "https://mba.grad.lvc.edu",
    "gtm_code": "GTM-P8MCP5R",
}